export const getTokens = (query: URLSearchParams) => {
  return {
    device_token: query.get("device_token"),
    car_token: query.get("car_token"),
  };
};
